import React from 'react';
import styles from './MacFeature.module.css';
import {isMac} from "../../utils/general";

const MAC_APP_DL_LINK = 'https://tiiny.host/mac/plugin.dmg';

const MacFeature = () => {
  if (!isMac())
    return null

  const onClick = () => {
    window.location = MAC_APP_DL_LINK;
    if (gtag) {
      gtag('event', 'click', {'event_category' : 'Homepage', 'event_action' : 'DOWNLOAD'});
    }
  }

  return <div className={styles.section} onClick={onClick}>
      <div id="mac" className={styles.container}>
        <div>
          <img src="assets/img/apple.png" width={50}/>
        </div>
        <div className="ms-4">
          <h2 className={styles.title}>Sharing just got easier.</h2>
          <div className={styles.subtitle}>We're now available as a Mac App.</div>
          <div className="mt-3">
            <img src="assets/img/download.png" width={40}/> <span className={styles.iconLabel}>Download</span>
          </div>
        </div>
        <div className={styles.iconContainer}>
          <img src="assets/img/pdf-plugin.png" height={140}/>
        </div>
      </div>
  </div>
}

export default MacFeature;
